import Swiper from "../../assets/.npm/node_modules/swiper";
import Navigation from "../../assets/.npm/node_modules/swiper/modules/navigation.min.mjs";

export default () => {
  let ntSlide = new Swiper(".ntSwiper", {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,

    navigation: {
        nextEl: ".feature-next",
        prevEl: ".feature-prev",
    }
  });
}
  
